<template>
	<FooterFull>
		<template #additionalDisclaimer>
			<div v-if="props.showFeeWaiverDisclaimer" id="feeWaiverDisclaimer">
				<p>
					*Fundrise reserves the right to change or terminate this offer at any time for any reason at its
					sole discretion.
				</p>
				<br />
			</div>
			<FooterSocialProof />
			<div id="awardsDisclaimers">
				<p
					>Any third party publications reflect solely the opinions of the authors, do not reflect the views
					of Fundrise, and Fundrise does not independently certify the information contained therein. Any such
					content is meant for informational purposes only and is not intended to serve as a recommendation to
					buy or sell any security, and is not an offer or sale of any security, and is not intended to serve
					as the basis for any investment decision. Past performance is not indicative of future results, and
					all investments may result in total or partial loss.
				</p>
				<p
					>Fundrise was selected as one of the Best Real Estate Investing Apps for non-accredited investors by
					Business Insider on July 30, 2024. It was considered among real estate investing apps based on
					criteria including, but not limited to, fees, investment strategies, user experience, and investor
					services, such as access to diverse real estate assets, educational resources, and customer support.
					Information was gathered from the apps' websites, conversations with company representatives, and
					additional third-party reports. No compensation was exchanged for this recognition. The author is
					not a client of Fundrise; views may not be representative. For more information, visit
					<BaseLink
						class="text-color-current-color text-decoration-underline"
						:link="businessInsiderAwardLink"
						>here</BaseLink
					>.</p
				>
				<p
					>Fundrise was selected for the Inc. 5000 list in August 2025, recognized as one of the
					fastest-growing private companies in America. It was considered among an unknown number of
					competitors based on criteria including, but not limited to, revenue growth, business model
					innovation, and market impact. Information was gathered from company-submitted data, augmented by
					independent research, and third-party reports. No compensation was exchanged for this recognition,
					however, Fundrise paid an application fee to be considered for this list. The author is not a client
					of Fundrise. For more information, visit
					<BaseLink class="text-color-current-color text-decoration-underline" :link="inc5000Link"
						>here</BaseLink
					>.</p
				>
				<p
					>Fundrise was recognized as one of the Deloitte Technology Fast 500 companies in November 2024. It
					was considered among an unknown number of competitors based on criteria including, but not limited
					to, company history, revenue growth, and the contribution of proprietary IP and/or technology to
					operating revenue. This ranking is compiled from company-submitted data and public company database
					research conducted by Deloitte LLP. No compensation was exchanged for this recognition, however,
					Fundrise paid an application fee to be considered for this list. The author is not a client of
					Fundrise. For more information, visit
					<BaseLink class="text-color-current-color text-decoration-underline" :link="deloitteLink">
						here</BaseLink
					>.</p
				>
				<p
					>Fundrise was selected as one of the World's Top 250 Fintech Companies by CNBC in July 2024. It was
					considered among 2000 fintech companies based on criteria including, but not limited to, innovation
					in financial technology, market impact, user experience, and the range of services offered, such as
					real estate investment opportunities and customer support. Information was gathered from company
					websites, conversations with company representatives, and additional third-party reports. No
					compensation was exchanged for this recognition. The author is not a client of Fundrise; views may
					not be representative. For more information, visit
					<BaseLink class="text-color-current-color text-decoration-underline" :link="cbncLink">here</BaseLink
					>.</p
				>

				<br />
			</div>
		</template>
	</FooterFull>
</template>

<script setup lang="ts">
import FooterFull from '@components/footer/footer-full.vue';
import FooterSocialProof from '@components/footer/footer-social-proof.vue';
import { Link } from 'types/layout';

interface Props {
	showFeeWaiverDisclaimer?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
	showFeeWaiverDisclaimer: true
});

const businessInsiderAwardLink: Link = {
	href: 'https://www.businessinsider.com/personal-finance/investing/best-real-estate-investing-platforms',
	target: '_blank'
};

const cbncLink: Link = {
	href: 'https://www.cnbc.com/the-worlds-top-250-fintech-companies-2024/',
	target: '_blank'
};

const deloitteLink: Link = {
	href: 'https://www.deloitte.com/us/en/Industries/tmt/content/fast500-winners.html',
	target: '_blank'
};

const inc5000Link: Link = {
	href: 'https://www.inc.com/inc5000/2025',
	target: '_blank'
};
</script>
